import { Image } from 'components'
import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper'
import { useResponsive } from 'hooks/useResponse'

import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import './styles.css'

const Wrap = styled.div`
  width: 100%;
  padding: 80px 0px;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 0px;
`

const DotList = styled.div`
  margin: 0 auto;
  margin-top: 20px;
  width: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
`

const Dot = styled.div<{ active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #01142a;
  cursor: pointer;
  opacity: ${({ active }) => {
    if (active) {
      return 1
    }
    return 0.5
  }};
`

const SliderArrowWrap = styled.div`
  display: none;
`

const StyledSwiperSlide = styled(SwiperSlide)`
  // when sliders length gt 1
  position: relative;
  &:hover ${SliderArrowWrap} {
    display: flex;
    z-index: 0;
  }
`

const GrandientWrap = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  position: absolute;
  left: 0px;
  top: 80px;
  width: 300px;
  height: 360px;
  z-index: 99999;
  background: linear-gradient(90deg, #ffffff, 40%, rgba(255, 255, 255, 0) 70.25%);
  @media (max-width: 1200px) {
    display: none;
  }
`

const GrandientWrap1 = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  position: absolute;
  right: 0px;
  top: 80px;
  width: 300px;
  height: 360px;
  z-index: 99999;
  background: linear-gradient(-90deg, #ffffff, 40%, rgba(255, 255, 255, 0) 70.25%);
  @media (max-width: 1200px) {
    display: none;
  }
`

// const Actions = () => {
//   const swiper = useSwiper()

//   const slideTo = React.useCallback(
//     (direction: 'prev' | 'next') => {
//       if (direction === 'prev' && !swiper.isBeginning) {
//         swiper.slidePrev()
//       }
//       if (direction === 'next' && !swiper.isEnd) {
//         swiper.slideNext()
//       }
//     },
//     [swiper]
//   )

//   return (
//     <SliderArrowWrap>
//       <ReverseArrow
//         onClick={slideTo.bind(null, 'prev')}
//         style={{ cursor: swiper.isBeginning ? 'not-allowed' : 'pointer' }}
//       >
//         <Image
//           src={require('../../../assets/images/lottery/banner-arrow-right.png').default}
//           width="52px"
//           height="52px"
//           alt="banner-arrow-left"
//         />
//       </ReverseArrow>
//       <Arrow onClick={slideTo.bind(null, 'next')} style={{ cursor: swiper.isEnd ? 'not-allowed' : 'pointer' }}>
//         <Image
//           src={require('../../../assets/images/lottery/banner-arrow-right.png').default}
//           width="52px"
//           height="52px"
//           alt="banner-arrow-right"
//         />
//       </Arrow>
//     </SliderArrowWrap>
//   )
// }

const Banner: React.FunctionComponent = () => {
  const [active, setActive] = React.useState(0)
  const history = useHistory()
  const { isMobile } = useResponsive()

  const sliders = [
    // {
    //   name: '1',
    //   value: '1',
    //   route: '/',
    //   image: {
    //     thumbnail: require('../../../assets/images/lottery/banner-1.webp').default,
    //   },
    // },
    {
      name: '1',
      value: '1',
      route: '/lottery',
      image: {
        thumbnail: require('../../../assets/images/lottery/banner-2.webp').default,
      },
    },
    {
      name: '2',
      value: '2',
      route: '/prediction',
      image: {
        thumbnail: require('../../../assets/images/lottery/banner-3.webp').default,
      },
    },
    {
      name: '3',
      value: '3',
      route: '/',
      image: {
        thumbnail: require('../../../assets/images/lottery/banner-1.webp').default,
      },
    },
  ]

  const slidesPerViews = React.useMemo(() => {
    if (document.body.clientWidth && document.body.clientWidth > 1200) {
      return 1 + (document.body.clientWidth - 1200 - 24 * 2) / 1200
    }
    if (document.body.clientWidth && document.body.clientWidth < 768) {
      return 1
    }
    return 1.56
  }, [])

  return (
    <Wrap>
      <GrandientWrap visible={active !== 0} />
      <GrandientWrap1 visible={active !== sliders.length - 1} />
      <Swiper
        slidesPerView={slidesPerViews}
        spaceBetween={24}
        centeredSlides={true}
        className="mySwiper"
        initialSlide={0}
        onActiveIndexChange={(e) => setActive(() => e.activeIndex)}
        enabled={true}
        modules={[Autoplay]}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
      >
        {sliders.map((s) => {
          return (
            <StyledSwiperSlide key={s.name} style={{ borderRadius: '20px', width: '1200px', cursor: 'pointer' }}>
              <Image
                onClick={() => {
                  if (s.route && !s.route.startsWith('http')) {
                    history.push(s.route)
                  }
                  if (s.route && s.route.startsWith('http')) {
                    window.open(s.route, '_blank')
                  }
                }}
                src={s.image.thumbnail}
                width="1200px"
                height={isMobile ? '200px' : '360px'}
                alt="img"
                style={{ borderRadius: '20px' }}
              />
              {/* {active === index && <Actions />} */}
            </StyledSwiperSlide>
          )
        })}
      </Swiper>
      <DotList>
        {sliders.map((dot, index) => {
          return <Dot key={dot.route} active={index === active} />
        })}
      </DotList>
    </Wrap>
  )
}

export default Banner
